import React, { useCallback, useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "../platformComponents";
import { IS_WEB } from "@adgm/libs";
import {
  colors,
  fontFamily,
  fontSize,
  fontWeight,
  margin,
  padding,
  radius,
} from "../styles/common";
import arrowIcon from "../assets/images/select_arrow_down.webp";
import { CommonImage } from "../common";

type TCollapsibleSectionProps = {
  /** 标题文本 */
  title?: string;
  titleNode?: React.ReactNode;
  /** 是否可折叠，默认true */
  collapsible?: boolean;
  /** 默认是否折叠，默认false */
  defaultCollapsed?: boolean;
  /** 子内容 */
  children: React.ReactNode;
  /** 自定义样式 */
  style?: object;
  contentStyle?: object;
  /** 状态变更回调 */
  onToggle?: (collapsed: boolean) => void;
};

export const CollapsibleSection: React.FC<TCollapsibleSectionProps> = ({
  title,
  titleNode,
  collapsible = true,
  defaultCollapsed = false,
  children,
  style,
  contentStyle,
  onToggle,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  // 处理折叠状态切换
  const handleToggle = useCallback(() => {
    if (!collapsible) return;

    setCollapsed(prev => {
      const newCollapsed = !prev;
      // 触发回调
      onToggle?.(newCollapsed);
      return newCollapsed;
    });
  }, [collapsible, onToggle]);

  return (
    <View style={[styles.container, style]}>
      <TouchableOpacity
        activeOpacity={collapsible ? 0.7 : 1}
        // platformComponents导出的TouchableOpacity。在web端缺少onPress的props定义。但功能正常
        // @ts-ignore - platformComponents type issue
        onPress={handleToggle}
        style={styles.header}
        disabled={!collapsible}>
        {titleNode ? (
          titleNode
        ) : (
          <Text style={styles.title} numberOfLines={2}>
            {title}
          </Text>
        )}
        {collapsible ? (
          <CommonImage
            source={arrowIcon}
            style={[
              styles.arrow,
              {
                transform: [{ rotate: collapsed ? "-90deg" : "0deg" }],
              },
            ]}
            width={14}
            height={14}
            resizeMode="contain"
          />
        ) : null}
      </TouchableOpacity>
      {!collapsible || !collapsed ? (
        <View style={[styles.content, contentStyle]}>{children}</View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: margin.m16,
    borderRadius: radius.r8,
    overflow: "hidden",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    flex: 1,
    fontSize: IS_WEB ? fontSize.f24 : fontSize.f16,
    color: colors.white,
    fontFamily: IS_WEB ? "Common-Bold" : fontFamily.commonBold,
    fontWeight: fontWeight.f700,
    marginRight: margin.m8,
  },
  arrow: {
    width: 12,
    height: 12,
  },
  content: {
    paddingVertical: padding.p16,
  },
});
